import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "./Swipers.css";

// import required modules
import { Pagination } from "swiper/modules";

// import swipercardImage1 from "../../Images/swipercardImage1.jpg";
import swipercardImage2 from "../../Images/swipercardImage2.jpg";
import swipercardImage3 from "../../Images/swipercardImage3.jpg";
// import swipercardImage4 from "../../Images/swipercardImage4.jpg";
import swipercardImage5 from "../../Images/swipercardImage5.jpg";
import swipercardImage6 from "../../Images/swipercardImage6.jpg";

export default function SwiperCard() {
  return (
    <>
      <Swiper
        // slidesPerView={3.2}
        
        spaceBetween={30}
        modules={[Pagination]}
        className="mySwiper"
        breakpoints={{
          1024: { slidesPerView: 3.2 }, // Large screens
          768: { slidesPerView: 2 }, // Tablets
          480: { slidesPerView: 1 }, // Mobile
          0: { slidesPerView: 1.2 }, // Ensure it works on all mobile sizes
        }}
      >
        <SwiperSlide>
          <div className="aboutImage">
            <h4>Elegant Glam Makeup</h4>
            <h2> Flawless Finish with Bold Eyes</h2>
          </div>
          <div className="makeupImage">
            <img src={swipercardImage5}  alt="swipercardImage5"/>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="aboutImage">
            <h4>Elegant Glam Makeup</h4>
            <h2> Flawless Finish with Bold Eyes</h2>
          </div>
          <div className="makeupImage">
            <img src={swipercardImage3} alt="swipercardImage3" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="aboutImage">
            <h4>Elegant Glam Makeup</h4>
            <h2> Flawless Finish with Bold Eyes</h2>
          </div>
          <img src={swipercardImage2} alt="swipercardImage2" />
        </SwiperSlide>
        <SwiperSlide>
          <div className="aboutImage">
            <h4>Elegant Glam Makeup</h4>
            <h2> Flawless Finish with Bold Eyes</h2>
          </div>
          <img src={swipercardImage6} alt="swipercardImage6" />
        </SwiperSlide>
      </Swiper>
    </>
  );
}
